module.exports = __webpack_public_path__ + "static/img/my-flow-chart.f867957c.png";